document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("valentineBtn");
  if (!btn) return;

  const collectionMap = {
    women: {
      walking: "womens-dog-walking",
      gardening: "womens-gardening",
      horse: "womens-horse-stable",
      farming: "womens-farm-work",
      festival: "womens-festival-boots",
      commuting: "womens-commuting",
      skiing: "womens-arctic-winter-boots",
      fishing: "fishing-boots"
    },
    men: {
      walking: "mens-dog-walking",
      gardening: "mens-gardening",
      horse: "mens-horse-stable",
      farming: "mens-farm-work",
      festival: "mens-festival-boots",
      commuting: "mens-commuting",
      skiing: "mens-arctic-winter-boots",
      fishing: "fishing-boots"
    }
  };

  // Products to exclude
  const excludedHandles = new Set([
    'unisex-muck-boot-bag-moss',
    'unisex-muck-boot-jack-brown',
    'unisex-rubber-boot-care-spray-white'
  ]);

  // Cache DOM elements
  const elements = {
    container: document.getElementById("valentineResults"),
    pageTitle: document.querySelector(".page__title"),
    pageCopy: document.querySelector(".valentine-quiz-wrapper p"),
    quiz: document.querySelector(".valentine-quiz"),
    heading:document.querySelector(".section-headers"),
    interestSelect: document.getElementById("interestSelect"),
    activitySelect: document.getElementById("activitySelect"),
    customerName: document.getElementById("customerName")
  };

  btn.addEventListener("click", async () => {
    const interest = elements.interestSelect.value;
    const activity = elements.activitySelect.value;
    const customerName = elements.customerName?.value.trim() || "Guest";

    if (!interest || !activity) {
      alert("Please select both options");
      return;
    }

    const handle = collectionMap[interest]?.[activity];
    if (!handle) {
      console.warn("No collection mapped for:", interest, activity);
      return;
    }

    // Loading state
    elements.container.innerHTML = "<p>Finding the perfect match…</p>";
    [elements.pageTitle, elements.pageCopy, elements.quiz,elements.heading].forEach(el => {
      if (el) el.style.display = "none";
    });

    try {
      const res = await fetch(`/collections/${handle}?section_id=valentine-products`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const html = await res.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const productCards = tempDiv.querySelectorAll(".product-card");

      const isWomenFlow = interest === "women";
      const isMenFlow = interest === "men";

      let desiredCount = 5;
      let validCount = 0;

      productCards.forEach(product => {
        const productLink = product.querySelector('a[href*="/products/"]');
        const title = product.dataset.title?.toLowerCase() || "";

        if (!productLink) {
          product.remove();
          return;
        }

        const productHandle = productLink
          .getAttribute("href")
          .split("/products/")[1]
          .split("?")[0];

        // Exclusion list
        if (excludedHandles.has(productHandle)) {
          product.remove();
          return;
        }

        // Gender filter via title prefix
        if (isWomenFlow) {
          if (
            !title.startsWith("women's") &&
            !title.startsWith("womens") &&
            !title.startsWith("unisex")
          ) {
            product.remove();
            return;
          }
        }

        if (isMenFlow) {
          if (
            !title.startsWith("men's") &&
            !title.startsWith("mens") &&
            !title.startsWith("unisex")
          ) {
            product.remove();
            return;
          }
        }

        // Valid product
        validCount++;

        if (validCount > desiredCount) {
          product.remove();
          return;
        }
      });

      // Add UTM parameters to all product links
      tempDiv.querySelectorAll('a[href*="/products/"]').forEach(link => {
        try {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set("utm_source", "valentine_quiz");
          url.searchParams.set("utm_medium", "quiz");
          url.searchParams.set("utm_campaign", `${interest}_${activity}`);
          url.searchParams.set("utm_content", customerName);
          link.href = url.toString();
        } catch (e) {
          console.warn("Failed to add UTM to link:", link.href);
        }
      });

      // Optional: Analytics
      if (typeof gtag !== "undefined") {
        gtag("event", "valentine_quiz_completed", {
          customer_name: customerName,
          interest: interest,
          activity: activity,
          collection_handle: handle
        });
      }

      // Render results
      elements.container.innerHTML = tempDiv.innerHTML;
      elements.container.scrollIntoView({ behavior: "smooth" });

    } catch (e) {
      console.error("Error fetching collection:", e);
      elements.container.innerHTML = "<p>Something went wrong. Please try again.</p>";
    }
  });
});
